import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { getUsername } from '@schaeffler/azure-auth';

@Injectable({ providedIn: 'root' })
export class UserHeaderService {
  private readonly store = inject(Store);

  readonly username = toSignal(this.store.select(getUsername), {
    initialValue: '',
  });

  readonly initials = computed(() => {
    const name = this.username();
    if (!name) return '?';
    return name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join('');
  });
}
